
import React, { useEffect } from 'react';
import { useData } from '../context/DataContext';
import DOMPurify from 'dompurify';

const Terms: React.FC = () => {
  const { settings } = useData();

  useEffect(() => {
    document.title = settings.termsConditionsSeoTitle || settings.termsConditionsTitle || 'Terms & Conditions | Automax';
  }, [settings.termsConditionsSeoTitle, settings.termsConditionsTitle]);

  return (
    <div className="min-h-screen bg-white pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-bold text-gray-900 uppercase tracking-wider mb-8 border-b pb-4">
          {settings.termsConditionsTitle || 'Terms & Conditions'}
        </h1>
        <div
          className="prose prose-lg max-w-none text-gray-700 whitespace-pre-wrap"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(settings.termsConditionsContent) }}
        />
      </div>
    </div>
  );
};

export default Terms;
